<template lang="pug">
    //- .container
    //-     .columns
    //-         .col-12
            
    .timeline
        .title
                | Paciente {{patientName}}
        .col-12(v-if="hospitalizationData != null")
            button.btn.btn-primary(v-on:click="rows.push({})")
                | Añadir fecha
            button.btn.btn-secondary.ml-2(v-on:click="save")
                | Guardar
            table.table.table-striped 
                thead
                    tr
                        th
                            | Fecha
                        th(v-for="hour in hours")
                            | {{hour}}:00
                tbody
                
                    tr(v-for="row in rows")
                        td
                            date-time(v-model="row.date")
                        td(v-for="hour in hours")
                            input(v-model="row[hour]")

</template>

<script>
// import Gun from "gun";
// const sea = Gun.SEA;


import Swal from "sweetalert2"
import { Datetime } from "vue-datetime";
import gun from "../managers/gun";
export default {
    components: {
        "date-time": Datetime
    },
    data() {
        return {
            patientName: "ss",
            hospitalizationID: "",
            hospitalizationData: null,
            rows: [],
            hours:[1,2,3,4,5,6]
        }
    },
    created() {
        this.hospitalizationID = this.$route.params.id
            gun.get("hospitalizations").get(this.$route.params.id).once(async (data) => {
            this.hospitalizationData = data
            this.patientName = await gun.user(data.patient).get("profile").get("name")
            
            // if(data.rows !=  null) {
            //     debugger
                this.rows = data.rows || []
            // }
            // if(data.rows) {
            //     this.rows = data.rows
            // }

        })
    },
    methods: {
        save() {
                  Swal.fire({
        title: "¿Estás seguro?",
        showCancelButton: true,
        confirmButtonText: "Sí",
        showLoaderOnConfirm: true,
        preConfirm: () => {
               this.hospitalizationData.rows = JSON.stringify(this.rows)
             return gun.get("hospitalizations").get(this.$route.params.id).put(this.hospitalizationData).then()
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then(result => {
        if (result.value) {
          Swal.fire({
            title: `¡Creado!`
          });

          this.$router.push({ name: "mi-registro" });
        }
      });
     
        }
    }
}
</script>

<style lang="scss" scoped>
    .table.table-striped {
        background-color: white;
    }
</style>